module.exports = __webpack_public_path__ + "static/media/Fresh_Grazel_TH.b98dab1d.png";